import * as z from 'zod';

import { bdQuerySchema } from '@/_pages/settings/business-disciplines/shared';
import { departmentQuerySchemaBase } from '@/_pages/settings/departments/shared';
import { locationQuerySchema } from '@/_pages/settings/preferred-locations/shared/schemas';
import { preferredRelationsShipsQuerySchema } from '@/_pages/settings/preferred-relationships/shared';
import { salaryGradeQueryLinkerSchema } from '@/_pages/settings/salary-grades/shared';
import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';
import { statusQuerySchema } from '@/_schemas/status-input';

export const jobPositionBaseQuerySchema = z.object({
  id: z.number(),
  name: z.string().min(3),
  parent_id: z.number().nullable(),
  status: statusQuerySchema,

  department_id: z.number().nullable(),
  department: departmentQuerySchemaBase.nullable(),

  business_discipline_id: z.number().nullable(),
  business_discipline: bdQuerySchema.nullable(),

  preferred_relationship_id: z.number().nullable(),
  preferred_relationship: preferredRelationsShipsQuerySchema.nullable(),

  preferred_location_id: z.number().nullable(),
  preferred_location: locationQuerySchema.nullable(),

  salary_grade_id: z.number().nullable(),
  salary_grade: salaryGradeQueryLinkerSchema.nullable(),

  result_statement: z.string().nullable(),
  strategic_work: z.string().nullable(),
  tactical_work: z.string().nullable(),
  standards_work: z.string().nullable(),

  need_to_succeed: z.string().nullable(),
  expectations: z.string().nullable(),
  position_overview: z.string().nullable(),
  applicant_questions: z.string().nullable(),
  interview_questions: z.string().nullable(),
});

export const jobPositionQuerySchema = jobPositionBaseQuerySchema.extend({
  parent: jobPositionBaseQuerySchema.nullish(),
  children: z.array(jobPositionBaseQuerySchema).nullish(),
});

export type JobPositionQuerySchema = z.infer<typeof jobPositionQuerySchema>;

export const jobPositionsQueryAllSchema = paginatedResponseSchema(jobPositionQuerySchema);

export type JobPositionsQueryAllSchema = z.infer<typeof jobPositionsQueryAllSchema>;
